import React, { PureComponent } from 'react';
import { IEasyPay, ITransactionItem } from '@src/interfaces/ITransactionState';
import { formatMoney, getTimeFromTimeServer } from '@src/utils/format';

interface Props {
  data: ITransactionItem;
}

export class KantanKessaiOtherInfo extends PureComponent<Props> {
  render() {
    const data = this.props.data;
    const easyInfo = data.easy_info;
    const easyPayListLength = easyInfo && easyInfo.easy_pay_list.length;
    const lastElementEasyPayList = easyInfo && easyPayListLength
      ? easyInfo.easy_pay_list[easyPayListLength - 1]
      : {} as IEasyPay;

    const datetime = lastElementEasyPayList.used_date
      ? getTimeFromTimeServer(
        lastElementEasyPayList.used_date.replace('Z', '+09:00')
      )
      : '';

    const listInfos = [
      {
        title: '【サービス名／お支払金額】',
        value:
          data.store_name &&
          easyInfo &&
          lastElementEasyPayList.used_amount
            ? `${data.store_name}／${
              formatMoney(lastElementEasyPayList.used_amount)
            }円`
            : ''
      },
      {
        title: '【ご利用日】',
        value: datetime
          ? `${datetime.year}/${datetime.month}/${datetime.day}`
          : ''
      },
      {
        title: '【決済情報番号】',
        value: easyInfo && easyInfo.pay_info_no ? easyInfo.pay_info_no : ''
      },
      {
        title: '【お問い合わせ先電話番号】',
        value: easyInfo && easyInfo.svc_tel ? easyInfo.svc_tel : ''
      },
      {
        title: '【お問い合わせ先URL】',
        value: easyInfo && easyInfo.svc_inq_url ? easyInfo.svc_inq_url : ''
      },
      {
        title: '【お支払い方法】',
        value: easyInfo && lastElementEasyPayList.paymnt_method_name
          ? lastElementEasyPayList.paymnt_method_name
          : ''
      },
      {
        title: '【ご利用Pontaポイント】',
        value: easyInfo && easyInfo.use_auid_pt
          ? `${formatMoney(easyInfo.use_auid_pt)} ポイント`
          : ''
      },
      {
        title: '【ご利用auポイント】',
        value: easyInfo && easyInfo.use_pt
          ? `${formatMoney(easyInfo.use_pt)} ポイント`
          : ''
      },
      {
        title: '【摘要】',
        value: easyInfo && easyInfo.cmdty
          ? easyInfo.cmdty
          : ''
      },
      {
        title: '【種別】',
        value: easyInfo && easyInfo.details_status
          ? easyInfo.details_status === '1' ? '支払い確定' : '確定前'
          : ''
      }
    ];

    return (
      <div className="other-informations">
        <div className="list-form-rows">
          <div className="form-row-no-border">備考</div>
          {listInfos.map((item, index) => (
            <div key={index} className="form-row-no-border">
              {item.title}{item.value}
            </div>
          ))}
        </div>
      </div>
    );
  }
};
